// extracted by mini-css-extract-plugin
module.exports = {"dateRange":"Vacation_dateRange_Wa-10","notice":"Vacation_notice_1MlCb"};